import {
  removeMember as publicRemoveMember,
  searchTeam as publicSearchTeam,
  getRolesInfo as publicGetRolesInfo,
  changeRoleV2 as publicChangeRoleV2,
  updateTeamMemberAssignments as publicUpdateTeamMemberAssignments,
} from './identity-roles-v1-user-users.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const removeMember: MaybeContext<
  BuildRESTFunction<typeof publicRemoveMember> & typeof publicRemoveMember
> = /*#__PURE__*/ createRESTModule(publicRemoveMember);
export const searchTeam: MaybeContext<
  BuildRESTFunction<typeof publicSearchTeam> & typeof publicSearchTeam
> = /*#__PURE__*/ createRESTModule(publicSearchTeam);
export const getRolesInfo: MaybeContext<
  BuildRESTFunction<typeof publicGetRolesInfo> & typeof publicGetRolesInfo
> = /*#__PURE__*/ createRESTModule(publicGetRolesInfo);
/** @internal */
export const changeRoleV2: MaybeContext<
  BuildRESTFunction<typeof publicChangeRoleV2> & typeof publicChangeRoleV2
> = /*#__PURE__*/ createRESTModule(publicChangeRoleV2);
export const updateTeamMemberAssignments: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTeamMemberAssignments> &
    typeof publicUpdateTeamMemberAssignments
> = /*#__PURE__*/ createRESTModule(publicUpdateTeamMemberAssignments);

export {
  ResourceType,
  ConditionAttributeType,
  SubjectType,
  SubjectContextType,
  InviteStatus,
  SimpleConditionOperator,
  JoinedConditionOperator,
  ScopeLevel,
  Visibility,
  PeopleType,
  AccountGroup,
  RoleLevel,
  OrderField,
  Direction,
  FacetType,
  RoleLevelRestriction,
  EditorType,
  RoleVisibility,
  PolicyType,
  Effect,
} from './identity-roles-v1-user-users.universal.js';
export {
  User,
  Name,
  Assignment,
  AssignedPolicy,
  Restriction,
  RestrictionRestrictionsOneOf,
  ApiResource,
  Conditions,
  ApiCondition,
  SiteRestriction,
  CompanionResource,
  LocationsRestriction,
  Subject,
  SubjectContext,
  GetTeamRequest,
  Paging,
  GetTeamResponse,
  AccountInvite,
  InviteResourceAssignment,
  InviteAssignment,
  FullNameResource,
  FullNameResourceResourceContextOneOf,
  SiteResourceContext,
  AccountResourceContext,
  OrganizationResourceContext,
  Resource,
  PolicyCondition,
  ConditionType,
  ConditionTypeOfOneOf,
  SimpleCondition,
  SimpleConditionValue,
  SimpleConditionValueValueOneOf,
  JoinedCondition,
  EnvironmentCondition,
  EnvironmentConditionConditionOneOf,
  ExperimentCondition,
  Condition,
  ConditionOperator,
  ConditionOperatorOperatorsOneOf,
  EqualOperator,
  ConditionValue,
  ConditionValueValueOneOf,
  LikeOperator,
  ExperimentOperator,
  DependOnOperator,
  AccountInfo,
  ApiPolicy,
  PredefinedRoles,
  PredefinedRole,
  Role,
  ChangeRoleRequest,
  ChangeRoleResponse,
  RemoveMemberRequest,
  RemoveMemberResponse,
  GetUsersRequest,
  GetUsersResponse,
  GetScopesRequest,
  GetScopesResponse,
  ScopeArea,
  PermissionScope,
  GetScopesV2Request,
  GetScopesV2Response,
  ScopeAreaV2,
  PermissionScopeV2,
  GetPeopleRequest,
  PeopleResource,
  PeopleResourceResourceTypeOneOf,
  FolderResource,
  GetPeopleResponse,
  People,
  Person,
  PersonPersonOneOf,
  Contributor,
  PersonMetaData,
  TeamMember,
  GetTeamV2Response,
  GetTeamInvitesRequest,
  GetTeamInvitesResponse,
  Invite,
  ApiInviteAssignment,
  GetPoliciesRequest,
  AreasFilter,
  GetPoliciesResponse,
  SearchTeamRequest,
  Ordering,
  SearchTeamResponse,
  Facet,
  FacetValue,
  TeamMemberV3,
  TeamMemberV3MembersOneOf,
  UserV3,
  AssignmentV3,
  AssignedSubject,
  InviteV3,
  InviteAssignmentV3,
  GetRolesRequest,
  GetRolesResponse,
  PredefinedRolesArea,
  PredefinedRoleV2,
  CustomRole,
  GetRolesInfoRequest,
  RolesInfoFilter,
  GetRolesInfoResponse,
  RoleInfo,
  CreateCustomRoleRequest,
  Policy,
  PolicyStatement,
  CreateCustomRoleResponse,
  ChangeRoleV2Request,
  ChangeRoleV2Response,
  UpdateTeamMemberAssignmentsRequest,
  UpdateTeamMemberAssignmentsResponse,
  GetSubjectsAssignmentsRequest,
  GetSubjectsAssignmentsResponse,
  SubjectAssignments,
  GetScopesByRoleRequest,
  GetScopesByRoleResponse,
  GetRolesV2Request,
  GetRolesV2Response,
  PredefinedRolesAreaV2,
  RoleInfoV2,
  CustomRoleV2,
  GetRolesBackofficeRequest,
  GetRolesBackofficeResponse,
  GetScopesBackofficeRequest,
  GetScopesBackofficeResponse,
  SearchTeamOptions,
  GetRolesInfoOptions,
  ChangeRoleV2Options,
  UpdateTeamMemberAssignmentsOptions,
} from './identity-roles-v1-user-users.universal.js';
export {
  ResourceTypeWithLiterals,
  ConditionAttributeTypeWithLiterals,
  SubjectTypeWithLiterals,
  SubjectContextTypeWithLiterals,
  InviteStatusWithLiterals,
  SimpleConditionOperatorWithLiterals,
  JoinedConditionOperatorWithLiterals,
  ScopeLevelWithLiterals,
  VisibilityWithLiterals,
  PeopleTypeWithLiterals,
  AccountGroupWithLiterals,
  RoleLevelWithLiterals,
  OrderFieldWithLiterals,
  DirectionWithLiterals,
  FacetTypeWithLiterals,
  RoleLevelRestrictionWithLiterals,
  EditorTypeWithLiterals,
  RoleVisibilityWithLiterals,
  PolicyTypeWithLiterals,
  EffectWithLiterals,
} from './identity-roles-v1-user-users.universal.js';
